import type { OTPType } from '@/types/api/auth';

const OtpTypeEnumMap = {
    Invitation: 1,
    VerifyPhone: 2,
    UpdatePhoneNumber: 3,
} as const;

export type OTPTypesEnumKeys = keyof typeof OtpTypeEnumMap;
export type OTPTypesEnumValues = (typeof OtpTypeEnumMap)[OTPTypesEnumKeys];

// Runtime enum for OTP Types
export const OTPTypesEnum: OTPType extends OTPTypesEnumValues
    ? typeof OtpTypeEnumMap
    : never = OtpTypeEnumMap;
